<template>
  <div v-if="isShowModal" class="loading-overlay">
    <div class="loading-parent" ref="popupRef">
      <div :style='{
        backgroundImage:`url(${icon_dm_top_bg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        backgroundPosition: "left",
        display:"flex",
        alignItems:"center",
        width:"100%",
        height:"66px",
        padding:"10px 15px",
        justifyContent:"space-between",
    }'>
        <div @click="capture" style="display:flex;flex-direction: column;align-items: flex-start;">
          <div :style="hcf.getTextStyle({
            color:'white',fontWeight:'bold',addSize:8,
          })">
            牢记最新域名
          </div>
          <div style="display:flex;flex-direction: row;">
            <div :style="hcf.getTextStyle({
              color:'#ddd',fontWeight:'bold',addSize:-2
            })">
              截图保存永不失联哦
            </div>
            <div style="border-radius: 10px;margin-bottom:3px;background-color: #f66f0e;padding:0 10px;margin-left: 10px;margin-top: 1px;">
              <div :style="hcf.getTextStyle({
              color:'#fff',fontWeight:'bold',addSize:-3,
            })">
                保存
              </div>
            </div>
          </div>
        </div>
        <img @click="closeModal" :src="icon_down_close" style="width:30px;margin-bottom: 10px;">
      </div>
      <div
          style="background-color: #eee;border-bottom-left-radius: 20px;border-bottom-right-radius:20px;width:100%;padding:10px;display:flex;flex-direction:column;align-items: center;justify-content: center;">
        <div style="display: flex;flex-direction: column;">
          <div @click="clickCopyDomain(newDomain)" style="background-color: #fff;border-radius: 12px;border-style: solid;width:80vw;border-color:#5552;padding:6px 15px;display:flex;flex-direction: row;align-items: center;justify-content: space-between;">
            <div :style='{
                  backgroundImage:`url(${icon_dm_list_logo})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "left",
                  display:"flex",
                  alignItems:"flex-end",
                  justifyContent:"center",
                  width:"50px",
                  height:"50px",
              }'>
              <div style="position: relative;bottom:-1px;font-weight: bold;color: black;font-size: 10px;">
                {{ useComApi.removeHttp(newDomain) }}
              </div>
            </div>
            <div :style="hcf.getTextStyle({
                color:'black',fontWeight:'bold',addSize:8,marginLeft:10,
              })">
              {{ useComApi.removeHttp(newDomain.toUpperCase()) }}
            </div>
            <div style="background-color: #fdd39c;padding:3px 15px;border-radius: 20px;">
              <div :style="hcf.getTextStyle({
                color:'#8f5408',fontWeight:'bold',addSize:1,
              })">
                复制
              </div>
            </div>
          </div>
          <div style="margin-top:3px;background-color: #fff;border-radius: 12px;border-style: solid;width:80vw;border-color:#5552;padding:6px 15px;display:flex;flex-direction: column;align-items: center;">
            <div v-for="(mValue,index) in domainList" :key="mValue">
              <div @click="clickCopyDomain(mValue)" style="margin-top:5px;background-color: #fff;border-radius: 30px;border-style: solid;width:75vw;border-color:#2221;padding:6px 8px;display:flex;flex-direction: row;align-items: center;justify-content: space-between;">
                <img :src="icon_dm_list_search" style="width:23px;">
                <div :style="hcf.getTextStyle({
                  color:'#8f5408',fontWeight:'bold',addSize:1,
                })">
                  {{useComApi.removeHttp(mValue)}}
                </div>
                <div style="background-color: #fdd39c;padding:3px 12px;border-radius: 20px;">
                  <div :style="hcf.getTextStyle({
                color:'#8f5408',fontWeight:'bold',addSize:-2,
              })">
                    复制
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <img :src="icon_dm_bottom_text" style="width:60%;">
        <div @click="clickDownBtn"
             style="margin-bottom: 10px;width:100%;height:39px;background-color: #6573f8;display: flex;align-items: center;justify-content: center;border-radius: 30px;">
          <div :style="hcf.getTextStyle({
          color:'white',fontWeight:'bold',addSize:3,
        })">
            下载APP
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
  import {onMounted, ref} from "vue";
  import {emitter, hcf, log} from "@/components/utils/HComFunctions.js";
  import icon_dm_bottom_text from '@/assets/icons/downloadmodal/dm_bottom_text.png';
  import icon_dm_list_logo from '@/assets/icons/downloadmodal/dm_list_logo.png';
  import icon_dm_top_bg from '@/assets/icons/downloadmodal/dm_top_bg.png';
  import icon_dm_list_search from '@/assets/icons/downloadmodal/dm_list_search.png';
  import icon_down_close from '@/assets/icons/downloadmodal/dm_list_close.png';
  import {showDialog, showToast} from "vant";
  import {hdi} from "@/components/utils/HDeviceInfo.js";
  import {useHComApi} from "@/hooks/useHComApi.js";
  let useComApi = useHComApi();
  let isShowModal = ref(false);
  let newDomain = ref("");
  let domainList = ref([]);

  let downTimer = null;

  //截图保存
  import html2canvas from "html2canvas";
  const popupRef = ref(null);
  function capture() {
    const el = popupRef.value;
    if (!el) return;

    html2canvas(el, {
      backgroundColor: null, // 保留透明背景
      useCORS: true, // 允许跨域图片
      scale: 2 // 高分辨率
    }).then((canvas) => {
      const link = document.createElement("a");
      link.download = "screenshot.png";
      link.href = canvas.toDataURL("image/png");
      link.click();
    });
  }


  onMounted(() => {
    emitter.on("DOWNLOAD_MODAL_VISIBLE", ({visible, dList = []}) => {
      isShowModal.value = visible;
      newDomain.value = dList[0];
      domainList.value = dList.length > 1
          ? dList.slice(1,dList.length)
          : [];
    });
  });

  function closeModal(){
    isShowModal.value = false;
  }
  function clickCopyDomain(domain){
    hcf.copyClipboard(domain);
  }
  function clickDownBtn() {
    if (hdi.platTypeNo === 3) {
      hcf.launchUrl(useComApi.h5DownloadIosUrl + "?code=" + hdi.inviteCode);
      if (downTimer) {
        clearTimeout(downTimer);
        downTimer = null;
      }
      downTimer = setTimeout(() => {
        showDialog({
          title: 'iPhone轻量版安装步骤',
          message: "\n1.打开 【设置】-【通用】-【VPN与设备管理】\n2.选择《永利皇宫》\n3.点击右上角【安装】按钮\n\n*安装后请返回主屏幕查看\n*如有遇到任何问题,请联系在线客服",
          confirmButtonText: "知道了",
          confirmButtonColor: hcf.getMainColor(),
          messageAlign: "left"
        });
      }, 3000);
    } else {
      hcf.launchUrl(useComApi.h5DownloadApkUrl + "?code=" + hdi.inviteCode)
    }
    isShowModal.value = false;
    localStorage.setItem("clicked_smd","1");
  }
</script>


<style scoped>


  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #000a;
    z-index: 9999; /* 确保在最上面 */
  }

  .loading-parent {
    width: 100%;
    margin: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
</style>
